import { useState, useEffect } from 'react';

const SHOP_RUNNER_EVENT_NAME = 'ShopRunnerChanged';

const useShopRunnerWatcher = () => {
  // Gets the ShopRunner token from the window object
  const srToken = window?.shopping?.analytics?.tracker?.shopper?.authToken;
  const [token, setToken] = useState(srToken);

  useEffect(() => {
    // Function to handle token updates
    const handleShopRunnerUpdate = () => {
      // Update the state when the window token changes
      const newToken = window?.shopping?.analytics?.tracker?.shopper?.authToken;
      setToken(newToken);
    };

    // Listen to the custom 'ShopRunnerChanged' event from the window
    window.addEventListener(SHOP_RUNNER_EVENT_NAME, handleShopRunnerUpdate);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener(SHOP_RUNNER_EVENT_NAME, handleShopRunnerUpdate);
    };
  }, []);

  return { token, isLoggedIn: !!token };
};

export default useShopRunnerWatcher;
